import React, { useState, useEffect } from 'react';
import {
  CarouselContainer,
  SlideContainer,
  SlideImage,
  Overlay,
  ImageTitle,
  Dots,
  Dot,
  NavButton,
  ContentWrapper,
} from './styles/CarouselStyles';
import { slides } from '../components/Home/Data/CarouselSlides';
import { ContentSection, Title, Subtitle } from './styles/HomeStyles';
import { HOME_TITLE, HOME_SUBTITLE } from './Home/consts';

const HomeCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const handlePrevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const handleNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  return (
    <CarouselContainer>
      {slides.map((slide, index) => (
        <SlideContainer key={slide.id} active={index === currentSlide}>
          <SlideImage src={slide.imageUrl} alt={slide.title} />
        </SlideContainer>
      ))}
      <Overlay />
      <ImageTitle>{slides[currentSlide].title}</ImageTitle>
      <NavButton direction="prev" onClick={handlePrevSlide}></NavButton>
      <NavButton direction="next" onClick={handleNextSlide}></NavButton>
      <Dots>
        {slides.map((_, index) => (
          <Dot
            key={index}
            active={index === currentSlide}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </Dots>
      <ContentWrapper>
        <ContentSection>
          <Title>{HOME_TITLE}</Title>
          <Subtitle>{HOME_SUBTITLE}</Subtitle>
        </ContentSection>
      </ContentWrapper>
    </CarouselContainer>
  );
};

export default HomeCarousel;
